export class SourceAccountCloudAttributes {
    'cloudProvider';
    'aws';
    'gcp';
    'azure';
    'mongoAtlas';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "azure",
            "baseName": "azure",
            "type": "AzureSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "mongoAtlas",
            "baseName": "mongoAtlas",
            "type": "MongoAtlasSourceAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceAccountCloudAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
